import { func, string, number, shape, oneOfType } from 'prop-types';
import DateInput from '../../shared/Date';
import Input from '../../shared/Input';
import { Box, FormStack, Stack } from '../../shared/layouts';
import Card from '../../shared/Card';
import Header from '../../shared/Header';
import Select from '../../shared/Select';
import { useContext } from 'react';
import WhiteLabelContext from '../../../context/WhiteLabelContext';
import LonelyPlaceholder from '../../shared/LonelyPlaceholder';
import {useTranslation} from "react-i18next";
import i18n from '../../../i18n';
import useIconLibrary from "../../../hooks/useIconLibrary";

export const getPropertyTypeOptions = () => [
  { label: i18n.t('Eigen woning'), value: 'owned' },
  { label: i18n.t('Huur woning'), value: 'rented' },
  { label: i18n.t('Anders'), value: 'other' },
];

const HomeSection = ({
  handleChange,
  type,
  taxation_value_amount,
  taxation_value_date,
  woz_value_amount,
  woz_value_date,
  indexed_value_amount,
  indexed_value_date,
  errors,
}) => {
  const { t } = useTranslation();
  const { canEditHouse } = useContext(WhiteLabelContext);
  const readOnly = !canEditHouse;
  const FormFiller = (props) => !readOnly && <Box {...props} />;
  const { HouseIcon } = useIconLibrary();

  const handleNumberChange = ({ target }) =>
    handleChange({
      target: {
        name: target.name,
        value: Number(target.value),
      },
    });

  return (
    <Card>
      <Stack space="m" width="100%">
        <Header
          title={t("Woninggegevens")}
          icon={<HouseIcon height="2rem" width="2rem" />}
          variant="section"
        />
        <FormStack space="m" readOnly={readOnly}>
          {/* Row */}
          <Select
            label={t("Type woning")}
            name="type"
            onChange={handleChange}
            options={getPropertyTypeOptions()}
            value={type}
            readOnly={readOnly}
          />
          <FormFiller />
          {/* Row */}
          <Input
            isCurrency
            label={t("Taxatiewaarde")}
            name="taxation_value_amount"
            onChange={handleNumberChange}
            value={taxation_value_amount}
            errors={errors.taxation_value_amount}
            readOnly={readOnly}
          />
          <DateInput
            label={t("Taxatiedatum")}
            name="taxation_value_date"
            onChange={handleChange}
            value={taxation_value_date}
            errors={errors['taxation_value_date']}
            readOnly={readOnly}
          />
          {/* Row */}
          <Input
            isCurrency
            label={t("WOZ-waarde")}
            name="woz_value_amount"
            onChange={handleNumberChange}
            errors={errors.woz_value_amount}
            value={woz_value_amount}
            readOnly={readOnly}
          />
          <Input
            label={t("WOZ-jaar")}
            name="woz_value_date"
            onChange={handleNumberChange}
            value={woz_value_date}
            errors={errors.woz_value_date}
            placeholder="JJJJ"
            readOnly={readOnly}
          />
          {/* Row */}
          <Input
            isCurrency
            label={t("Geïndexeerde waarde")}
            name="indexed_value_amount"
            onChange={handleNumberChange}
            value={indexed_value_amount}
            errors={errors.indexed_value_amount}
            readOnly={readOnly}
          />
          <DateInput
            label={t("Datum indexatie")}
            name="indexed_value_date"
            onChange={handleChange}
            value={indexed_value_date}
            errors={errors['indexed_value_date']}
            readOnly={readOnly}
          />
          <LonelyPlaceholder />
        </FormStack>
      </Stack>
    </Card>
  );
};

HomeSection.propTypes = {
  handleChange: func.isRequired,
  type: string,
  taxation_value_amount: number,
  taxation_value_date: string,
  woz_value_amount: number,
  woz_value_date: oneOfType([number, string]),
  errors: shape({}),
};

HomeSection.defaultProps = {
  type: '',
  taxation_value_amount: null,
  taxation_value_date: '',
  woz_value_amount: null,
  woz_value_date: null,
  indexed_value_amount: null,
  indexed_value_date: '',
  errors: {},
};

export default HomeSection;
